module.exports = __webpack_public_path__ + "img/kongbi.1eb562b2.jpg";